export const LIST_ORGANIZATIONS_START = 'LIST_ORGANIZATIONS_START';
export const LIST_ORGANIZATIONS_SUCCESS =
  'LIST_ORGANIZATIONS_SUCCESS';
export const LIST_ORGANIZATIONS_ERROR = 'LIST_ORGANIZATIONS_ERROR';
export const LIST_ORGANIZATIONS_END = 'LIST_ORGANIZATIONS_END';
